/** @jsxImportSource @emotion/react */

import React, { useEffect } from "react";

import {
  List,
  ListItem,
  ListItemText,
  IconButton,
  Box,
  TextField,
  Typography,
} from "@mui/material";
import { styles, LinkComp, SearchIconWrapper, Search } from "./headerStyle";
import SearchIcon from "@mui/icons-material/Search";
import { css } from "@emotion/react";
import { Link } from "react-router-dom";

const searchLi = css`
  color: #767676;
  font: normal 500 14px/22px "PingFang SC", "Hiragino Sans GB",
    "Noto Sans CJK SC", "Source Han Sans SC", "Microsoft YaHei", "SimHei",
    Helvetica, Arial, serif;
  padding-bottom: 6%;
  text-decoration: none;
`;

const searchResultBoxCss = (bottomPaddingBool) => css`
  display: flex;
  flex-direction: column;
  padding: ${bottomPaddingBool ? "21px 20px 20px 22px" : "0px"};
  background-color: #f5f5f5;
`;

const DrawerComp = ({
  responseData,
  tabValue,
  handleNavHover,
  handleNavClick,
  classes,
  v4,
  handleDrawerToggle,
  CancelIcon,
  borderTabValue,
  collection,
  setSearchTerm,
  debouncedSearchTerm,
  fetchMeiliSearchData,
  setCollection,
  searchTerm,
  navigate,
}) => {
  const [searchIconClicked, setSearchIconClicked] = React.useState(false);

  useEffect(() => {
    debouncedSearchTerm !== "" && fetchMeiliSearchData();
  }, [debouncedSearchTerm]);

  const handleClick = (target, url) => {
    if (target === "_blank") window.open(url, "_blank");
  };

  let secondLevelData;
  responseData.forEach((data) => {
    if (
      data?.children[0]?.children.length > 0 &&
      borderTabValue === data.dataAttribute &&
      !searchIconClicked
    ) {
      secondLevelData = data?.children.map((product) => {
        return (
          <Box key={v4()} sx={{ marginTop: "18%" }}>
            <Typography sx={{ mb: 1, ml: 1 }} variant="h6">
              {product?.title}
            </Typography>
            <Box className={classes.multiMegaWrapper}>
              {product?.children.map((d) => (
                <Box
                  key={v4()}
                  sx={{ width: "50%", height: "50%" }}
                  onClick={() => handleClick(d?.target, d?.url)}
                >
                  <Box
                    component="img"
                    sx={{ width: "100%", height: "100%", py: 2 }}
                    src={`${process.env.REACT_APP_BASEURL}${d?.thumbnailImage?.formats?.thumbnail.url}`}
                    onClick={() => {
                      d.target !== "_blank" && navigate(d.url);
                      handleDrawerToggle();
                    }}
                  ></Box>
                  <LinkComp
                    to={d.target === "_blank" ? "#" : d.url}
                    mobileview={1}
                    onClick={handleDrawerToggle}
                  >
                    {d.title}
                  </LinkComp>
                </Box>
              ))}
            </Box>
          </Box>
        );
      });
    } else if (
      data?.children.length > 0 &&
      borderTabValue === data.dataAttribute &&
      !searchIconClicked
    ) {
      secondLevelData = (
        <Box
          className={classes.newsSubNavBox}
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "baseline",
            left: "0px",
            marginTop: "17%",
          }}
        >
          {data.children.map((d, index) => {
            return (
              <LinkComp
                sx={{ margin: "15%", color: "#000000" }}
                to={d.target === "_blank" ? "#" : d.url}
                state={{ id: index }}
                key={v4()}
                onClick={() => {
                  handleClick(d.target, d.url);
                  handleDrawerToggle();
                }}
              >
                {d.title}
              </LinkComp>
            );
          })}
        </Box>
      );
    } else if (searchIconClicked) {
      secondLevelData = (
        <Box>
          <Box>
            <TextField
              sx={{ color: "black", backgroundColor: "#f5f5f5" }}
              InputProps={{
                sx: { height: 56, padding: 2 },
              }}
              id="standard-basic"
              // placeholder="EQS"
              variant="standard"
              fullWidth
              value={searchTerm}
              onChange={({ target }) => setSearchTerm(target.value)}
            />
          </Box>
          <Box css={() => searchResultBoxCss(collection?.length > 0)}>
            {collection &&
              collection.map((data, index) => {
                return (
                  <Link
                    to="/search"
                    state={{
                      searchedItem: data.title,
                    }}
                    onClick={() => {
                      setSearchIconClicked(false);
                      handleDrawerToggle();
                      setCollection();
                      setSearchTerm("");
                    }}
                    key={data + index}
                    css={searchLi}
                  >
                    {data.title}
                  </Link>
                );
              })}
          </Box>
        </Box>
      );
    }
  });

  return (
    responseData && (
      <Box
        sx={{
          display: "flex",
          position: "fixed",
          top: "0",
          height: "100%",
          backgroundColor: "#fff",
          width: "100%",
        }}
      >
        <List
          sx={{
            backgroundColor: "#000000",
            height: "100vh",
            width: "35%",
            display: "flex",
            flexDirection: "column",
            paddingTop: "90px",
          }}
          disablePadding
        >
          {responseData.map((page, index) => (
            <ListItem
              key={v4()}
              sx={{ padding: "20px 0px", margin: "10px 0", ...styles.li }}
              tabIndex={index + 1}
              className={
                tabValue === page.dataAttribute?.toLowerCase()
                  ? "list-active"
                  : ""
              }
            >
              <ListItemText
                primary={page.title}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  ...styles.genericHeaderStyling,
                }}
                onMouseOver={() => handleNavHover(page.dataAttribute)}
                onClick={() => {
                  setSearchIconClicked(false);
                  handleNavClick(page.dataAttribute, page.target);
                }}
              />
            </ListItem>
          ))}
        </List>
        <Box sx={{ width: "65%", overflowY: "auto" }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              width: "50%",
              position: "relative",
              left: "50%",
            }}
          >
            <Search
              onClick={() => setSearchIconClicked(!searchIconClicked)}
              sx={{ color: searchIconClicked ? "#007aff" : "black" }}
            >
              <SearchIconWrapper>
                <SearchIcon />
              </SearchIconWrapper>
            </Search>

            <IconButton
              size="large"
              aria-label="cancel the drawer"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleDrawerToggle}
              color="inherit"
              sx={{ display: { color: "#000000" } }}
            >
              <CancelIcon />
            </IconButton>
          </Box>
          {secondLevelData}
        </Box>
      </Box>
    )
  );
};

export default DrawerComp;
